//import { useState } from 'react';

export function Polygon_Draw() {
	/*const [radioSelection, setRadioSelection] = useState(1);
	const [angle1, setAngle1] = useState();
	const [angle2, setAngle2] = useState();
	const [angle3, setAngle3] = useState();
	const [side1, setSide1] = useState();
	const [side2, setSide2] = useState();
	const [side3, setSide3] = useState();
	const [changeMade, setChangeMade] = useState(false);
	const [changeHistory, setChangeHistory] = useState(["xx", "xx", "xx", "xx", "xx", "xx"]);

	const indent = 30;
	const svgHeight = 450;
	const svgWidth = svgHeight * 1.618;

	function changeHandler(getter, setter, change, e) {
		if (e.target.value != getter) {
			let validChange = true;
			if (change[0] == 'a') {
				if (e.target.value > 178 || e.target.value < 0) {
					validChange = false;
				}
			}
			const lastChar = e.target.value[e.target.value.length - 1];
			if (lastChar < '0' || lastChar > '9') {
				validChange = false;
			}
			if (validChange) {
				setter(e.target.value);
				const newHistory = ["xx", "xx", "xx", "xx", "xx"];
				let n = 0;
				changeHistory.map((e, i) => {
					if (e != change) { newHistory[n++] = e; }
				});
				if (e.target.value > 0) {
					setChangeHistory([change, newHistory[0], newHistory[1], newHistory[2], newHistory[3], newHistory[4]]);
				}
				else {
					setChangeHistory([newHistory[0], newHistory[1], newHistory[2], newHistory[3], newHistory[4], "xx"]);
				}
			}
			setChangeMade(true);
		}
	}

	function triangleInputs() {
		if (radioSelection == 1) {
			return (
				<>
					<div style={{ "paddingLeft": indent, "paddingTop": "600px" }}>
						Angle 1 = <input id="angle_1" type="text" size="1" defaultValue={angle1} className="centered"
							onChange={(e) => changeHandler(angle1, setAngle1, "a1", e)} /> &#176; &nbsp; &nbsp;
						Side length opposite angle 1 = <input id="side_1" type="text" size="1" defaultValue={side1} className="centered"
							onChange={(e) => changeHandler(side1, setSide1, "s1", e)} /> <br /> <br />
						Angle 2 = <input id="angle_2" type="text" size="1" defaultValue={angle2} className="centered"
							onChange={(e) => changeHandler(angle2, setAngle2, "a2", e)} /> &#176; &nbsp; &nbsp;
						Side length opposite angle 2 = <input id="side_2" type="text" size="1" defaultValue={side2} className="centered"
							onChange={(e) => changeHandler(side2, setSide2, "s2", e)} /> <br /> <br />
						Angle 3 = <input id="angle_3" type="text" size="1" defaultValue={angle3} className="centered"
							onChange={(e) => changeHandler(angle3, setAngle3, "a3", e)} /> &#176; &nbsp; &nbsp;
						Side length opposite angle 3 = <input id="side_3" type="text" size="1" defaultValue={side3} className="centered"
							onChange={(e) => changeHandler(side3, setSide3, "s3", e)} /> <br /> <br />
					</div>
				</>
			);
		}
	}

	function polygonOutput() {
		if (radioSelection == 1) {
			return (
				<>
					<svg width={svgWidth} height={svgHeight} style={{ "paddingTop": "100px" }}>
						<rect x="0" y="0" width="100%" height="100%" rx="5" fill="white" stroke="none" />
						{drawPolygon()}
					</svg>
				</>
			);
		}
	}

	function triangleInequalityCheck(s1, s2, s3) {
		if (s1 + s2 > s3) {
			if (s1 + s3 > s2) {
				if (s2 + s3 > s1) {
					return true;
				}
			}
		}
		return false;
	}

	function completePolygon() {

		function LofCDist(a, b, C) {
			return Math.sqrt(a * a + b * b - 2 * a * b * Math.cos(C / 180 * Math.PI));
		}

		function LofCAngle(a, b, c) {
			return Math.acos((a * a + b * b - c * c) / (2 * a * b)) * 180 / Math.PI;
		}

		const angles = [0, 0, 0];
		const sides = [0, 0, 0];
		changeHistory.map((change, index) => {
			if (change[0] == 'a') {
				const q = 0;
				switch (Number(change[1])) {
					case 1:
						if (angles[0] == 0) { angles[0] = Number(angle1); }
						break;
					case 2:
						if (angles[1] == 0) { angles[1] = Number(angle2); }
						break;
					case 3:
						if (angles[2] == 0) { angles[2] = Number(angle3); }
						break;
				}
			}
			else if (change[0] == 's') {
				switch (Number(change[1])) {
					case 1:
						if (sides[0] == 0) { sides[0] = Number(side1); }
						break;
					case 2:
						if (sides[1] == 0) { sides[1] = Number(side2); }
						break;
					case 3:
						if (sides[2] == 0) { sides[2] = Number(side3); }
						break;
				}
			}

			// Triangle Angle Sum
			if (angles[0] > 0 && angles[1] > 0 && angles[2] == 0) { angles[2] = 180 - angles[0] - angles[1]; }
			if (angles[0] > 0 && angles[1] == 0 && angles[2] > 0) { angles[1] = 180 - angles[0] - angles[2]; }
			if (angles[0] == 0 && angles[1] > 0 && angles[2] > 0) { angles[0] = 180 - angles[1] - angles[2]; }

			// Law of Cosines
			if (angles[0] > 0 && sides[0] == 0 && sides[1] > 0 && sides[2] > 0) {
				sides[0] = LofCDist(sides[1], sides[2], angles[0]);
			}
			if (angles[1] > 0 && sides[1] == 0 && sides[0] > 0 && sides[2] > 0) {
				sides[1] = LofCDist(sides[0], sides[2], angles[1]);
			}
			if (angles[2] > 0 && sides[2] == 0 && sides[1] > 0 && sides[0] > 0) {
				sides[2] = LofCDist(sides[1], sides[0], angles[2]);
			}
			if (sides[0] > 0 && sides[1] > 0 && sides[2] > 0 && triangleInequalityCheck(sides[0], sides[1], sides[2])) {
				if (angles[0] == 0) {
					angles[0] = LofCAngle(sides[1], sides[2], sides[0]);
				}
				if (angles[1] == 0) {
					angles[1] = LofCAngle(sides[0], sides[2], sides[1]);
				}
				if (angles[2] == 0) {
					angles[2] = LofCAngle(sides[1], sides[0], sides[2]);
				}
			}
			// Law of Sines
			angles.map((angle, i) => {
				if (angles[i] > 0 && sides[i] > 0) {
					const ratio = sides[i] / Math.sin(angles[i] / 180 * Math.PI);
					sides.map((side, j) => {
						if (j != i) {
							if (angles[j] > 0 && sides[j] == 0) {
								sides[j] = Math.sin(angles[j] / 180 * Math.PI) * ratio;
							}
							if (angles[j] == 0 && sides[j] > 0) {
								const perpendicularDist = Math.sin(angles[i] / 180 * Math.PI) * sides[j];
								if (sides[i] >= perpendicularDist && sides[i] > sides[j]) {
									angles[j] = Math.asin(sides[j] / ratio) * 180 / Math.PI;
								}
							}
						}
					})
				}
			})
		});
		if (angles[0] != angle1) { setAngle1(angles[0]); }
		if (angles[1] != angle2) { setAngle2(angles[1]); }
		if (angles[2] != angle3) { setAngle3(angles[2]); }
		if (sides[0] != side1) { setSide1(sides[0]); }
		if (sides[1] != side2) { setSide2(sides[1]); }
		if (sides[2] != side3) { setSide3(sides[2]); }
	}

	function drawPolygon() {

		function distance(pt1, pt2) {
			return Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		}

		const angleCount = (angle1 > 0) + (angle2 > 0) + (angle3 > 0);
		const sideCount = (side1 > 0) + (side2 > 0) + (side3 > 0);

		/*if (angleCount + sideCount < 3) {
			return (
				<>
					<text x={svgWidth / 2} y={svgHeight / 2} fill="red" textAnchor="middle" className="error-text">
						Not enough information!
					</text>
				</>
			);
		}*/

		/*if (angle1 == 0 && angle2 == 0 && angle3 == 0 && side1 > 0 && side2 > 0 && side3 > 0) {
			if (!triangleInequalityCheck(Number(side1), Number(side2), Number(side3))) {
				return (
					<>
						<text x={svgWidth / 2} y={svgHeight / 2} fill="red" textAnchor="middle" className="error-text">
							Triangle Inequality Theorem Failure!
						</text>
					</>
				);
			}
		}

		const x1 = [50, 51, 51];
		const y1 = [svgHeight - 50, svgHeight - 50, svgHeight - 51];
		const x2 = [svgWidth - 50, svgWidth - 51, svgWidth - 51];
		const y2 = [svgHeight - 50, svgHeight - 50, svgHeight - 51];
		const x3 = [svgWidth / 2, svgWidth / 2 - 1, svgWidth / 2 + 1];
		const y3 = [50, 51, 51];

		if (side3 > 0) {
			x1[1] = x1[0] + 50;
			x2[0] = x1[0] + Number(side3);
			x2[1] = x2[0] - 50;
			x2[2] = x2[0] - 1;
		}

		if (side1 == 0 || side2 == 0 || side3 == 0) {
			if (angle1 > 0) {
				x1[1] = x1[0] + (side3 > 0 ? 1 : 50);
				x1[2] = x1[0] + (side2 > 0 ? 1 : Math.cos(angle1 / 180 * Math.PI) * 50);
				y1[2] = y1[0] - (side2 > 0 ? 1 : Math.sin(angle1 / 180 * Math.PI) * 50);
			}
			if (angle2 > 0) {
				x2[1] = x2[0] - (side3 > 0 ? 1 : 50);
				x2[2] = x2[0] - (side1 > 0 ? 1 : Math.cos(angle2 / 180 * Math.PI) * 50);
				y2[2] = y2[0] - (side1 > 0 ? 1 : Math.sin(angle2 / 180 * Math.PI) * 50);
			}
			if (angle3 > 0) {
				if (x1[2] == x1[0] && y1[2] != y1[0]) { // right angle, left side
					x3[0] = x1[0];
					y3[0] = y1[0] - Math.tan(angle2 / 180 * Math.PI) * (x2[0] - x1[0]);
					x3[1] = x3[0];
					y3[1] = y3[0] + (side2 > 0 ? 0 : 50);
					x3[2] = x3[0] + (side1 > 0 ? 0 : Math.cos(angle2 / 180 * Math.PI) * 50);
					y3[2] = y3[0] + (side1 > 0 ? 0 : Math.sin(angle2 / 180 * Math.PI) * 50);
				}
				else if (x2[2] == x2[0] && y2[2] != y2[0]) { // right angle, right side
					x3[0] = x2[0];
					y3[0] = y2[0] - Math.tan(angle1 / 180 * Math.PI) * (x2[0] - x1[0]);
					x3[1] = x3[0] - (side2 > 0 ? 0 : Math.cos(angle1 / 180 * Math.PI) * 50);
					y3[1] = y3[0] + (side2 > 0 ? 0 : Math.sin(angle1 / 180 * Math.PI) * 50);
					x3[2] = x3[0];
					y3[2] = y3[0] + (side1 > 0 ? 0 : 50);
				}
				else if (angle1 == 0 && angle2 == 0) {
					const dx = Math.sin(angle3 / 360 * Math.PI);
					const dy = Math.cos(angle3 / 360 * Math.PI);
					x3[0] = x1[0] + dx * (side3 > 0 ? Number(side3) : 100);
					y3[0] = y1[0] - dy * (side3 > 0 ? Number(side3) : 100);
					x3[1] = x3[0] - (side3 > 0 ? 0 : dx * 50);
					y3[1] = y3[0] + (side3 > 0 ? 0 : dy * 50);
					x3[2] = x3[0] + (side3 > 0 ? 0 : dx * 50);
					y3[2] = y3[1];

					x1[1] = side3 == 0 ? x1[0] : x1[0] + 50;
					x1[2] = side2 == 0 ? x1[0] : x1[0] + dx * 50;
					y1[2] = side2 == 0 ? y1[0] : y1[0] - dy * 50;
					x2[0] = side3 == 0 ? x1[0] + 2 * dx * 100 : x1[0] + 2 * dx * Number(side3);
					x2[1] = side3 == 0 ? x2[0] : x2[0] - 50;
					x2[2] = side1 == 0 ? x2[0] : x2[0] - dx * 50;
					y2[2] = side1 == 0 ? y2[0] : y2[0] - dy * 50;
				}
				else {
					const slopeFrom1To3 = (y1[2] - y1[0]) / (x1[2] - x1[0]);
					const interceptFrom1To3 = y1[0] - slopeFrom1To3 * x1[0];
					const slopeFrom2To3 = (y2[2] - y2[0]) / (x2[2] - x2[0]);
					const interceptFrom2To3 = y2[0] - slopeFrom2To3 * x2[0];
					const xIntersect = (interceptFrom2To3 - interceptFrom1To3) / (slopeFrom1To3 - slopeFrom2To3);
					const yIntersect = slopeFrom1To3 * xIntersect + interceptFrom1To3;
					x3[0] = xIntersect;
					y3[0] = yIntersect;
					x3[1] = xIntersect - Math.sin((90 - angle1) / 180 * Math.PI) * 50;
					y3[1] = yIntersect + Math.cos((90 - angle1) / 180 * Math.PI) * 50;
					x3[2] = xIntersect + Math.sin((90 - angle2) / 180 * Math.PI) * 50;
					y3[2] = yIntersect + Math.cos((90 - angle2) / 180 * Math.PI) * 50;
				}
			}
		}
		else {
			const dx = (side2 * side2 - side1 * side1 + side3 * side3) / (2 * side3);
			const dy = Math.sqrt(side2 * side2 - dx * dx);
			x3[0] = x3[1] = x3[2] = x1[0] + dx;
			y3[0] = y3[1] = y3[2] = y1[0] - dy;
		}

		const dist3 = distance([x1[0], y1[0]], [x2[0], y2[0]]);
		const dist2 = distance([x1[0], y1[0]], [x3[0], y3[0]]);
		const dist1 = distance([x2[0], y2[0]], [x3[0], y3[0]]);

		if (dist1 < side1 - 1 || dist2 < side2 - 1 || dist3 < side3 - 1) {
			return (
				<>
					<text x={svgWidth / 2} y={svgHeight / 2} fill="red" textAnchor="middle" className="error-text">
						Can't form a triangle from this information!
					</text>
				</>
			);
		}

		// Don't overshoot the endpoint
		x1[1] = Math.min(x1[1], x2[0]);
		x1[2] = Math.min(x1[2], x3[0]);
		x2[1] = Math.max(x2[1], x1[0]);
		x2[2] = Math.max(x2[2], x3[0]);
		x3[1] = Math.max(x3[1], x1[0]);
		x3[2] = Math.min(x3[2], x2[0]);

		y1[2] = Math.max(y1[2], y3[0]);
		y2[2] = Math.max(y2[2], y3[0]);
		y3[1] = Math.min(y3[1], y1[0]);
		y3[2] = Math.min(y3[2], y2[0]);

		// Scale to the display box
		let width = Math.max(Math.abs(x2[0] - x1[0]), Math.abs(x3[0] - x1[0]), Math.abs(x3[0] - x2[0]));
		let height = Math.abs(y1[0] - y3[0]);

		const ratio = (svgWidth - 100) / width;
		[0, 1, 2].map((i) => {
			x1[i] = x1[0] + (x1[i] - x1[0]) * ratio;
			x2[i] = x1[0] + (x2[i] - x1[0]) * ratio;
			x3[i] = x1[0] + (x3[i] - x1[0]) * ratio;
			y1[i] = y1[0] + (y1[i] - y1[0]) * ratio;
			y2[i] = y1[0] + (y2[i] - y1[0]) * ratio;
			y3[i] = y1[0] + (y3[i] - y1[0]) * ratio;
		});
		width *= ratio;
		height *= ratio;

		if (height > svgHeight - 100) {
			const ratio = (svgHeight - 100) / height;
			[0, 1, 2].map((i) => {
				x1[i] = x1[0] + (x1[i] - x1[0]) * ratio;
				x2[i] = x1[0] + (x2[i] - x1[0]) * ratio;
				x3[i] = x1[0] + (x3[i] - x1[0]) * ratio;
				y1[i] = y1[0] + (y1[i] - y1[0]) * ratio;
				y2[i] = y1[0] + (y2[i] - y1[0]) * ratio;
				y3[i] = y1[0] + (y3[i] - y1[0]) * ratio;
			});
			width *= ratio;
			height *= ratio;
		}

		// Center the image
		const xMin = Math.min(x1[0], x2[0], x3[0]);
		const yMin = Math.min(y1[0], y2[0], y3[0]);
		const xMax = Math.max(x1[0], x2[0], x3[0]);
		const yMax = Math.max(y1[0], y2[0], y3[0]);

		const xOffset = (svgWidth - (xMax + xMin)) / 2;
		const yOffset = (svgHeight - (yMax + yMin)) / 2;

		[0, 1, 2].map((i) => {
			x1[i] += xOffset;
			y1[i] += yOffset;
			x2[i] += xOffset;
			y2[i] += yOffset;
			x3[i] += xOffset;
			y3[i] += yOffset;
		});

		return (
			<>
				{side1 > 0 && <line x1={x2[0]} y1={y2[0]} x2={x3[0]} y2={y3[0]} stroke="black" strokeWidth="3" />}
				{side1 == 0 && <line x1={x2[0]} y1={y2[0]} x2={x2[2]} y2={y2[2]} stroke="black" strokeWidth="3" strokeDasharray="10,10" />}
				{side1 == 0 && <line x1={x3[0]} y1={y3[0]} x2={x3[2]} y2={y3[2]} stroke="black" strokeWidth="3" strokeDasharray="10,10" />}
				{side2 > 0 && <line x1={x1[0]} y1={y1[0]} x2={x3[0]} y2={y3[0]} stroke="black" strokeWidth="3" />}
				{side2 == 0 && <line x1={x1[0]} y1={y1[0]} x2={x1[2]} y2={y1[2]} stroke="black" strokeWidth="3" strokeDasharray="10,10" />}
				{side2 == 0 && <line x1={x3[0]} y1={y3[0]} x2={x3[1]} y2={y3[1]} stroke="black" strokeWidth="3" strokeDasharray="10,10" />}
				{side3 > 0 && <line x1={x1[0]} y1={y1[0]} x2={x2[0]} y2={y2[0]} stroke="black" strokeWidth="3" />}
				{side3 == 0 && <line x1={x1[0]} y1={y1[0]} x2={x1[1]} y2={y1[1]} stroke="black" strokeWidth="3" strokeDasharray="10,10" />}
				{side3 == 0 && <line x1={x2[0]} y1={y2[0]} x2={x2[1]} y2={y2[1]} stroke="black" strokeWidth="3" strokeDasharray="10,10" />}
			</>
		);
	}

	document.getElementById("root").style.margin = "0 0";

	const one23 = [1, 2, 3];
	one23.map((num) => {
		const elementA = document.getElementById("angle_" + num);
		if (elementA != null) {
			switch (num) {
				case 1:
					elementA.value = angle1 > 0 ? Math.round(Number(angle1)) : "";
					break;
				case 2:
					elementA.value = angle2 > 0 ? Math.round(Number(angle2)) : "";
					break;
				case 3:
					elementA.value = angle3 > 0 ? Math.round(Number(angle3)) : "";
					break;
			}
		}
		const elementS = document.getElementById("side_" + num);
		if (elementS != null) {
			switch (num) {
				case 1:
					elementS.value = side1 > 0 ? Math.round(Number(side1)) : "";
					break;
				case 2:
					elementS.value = side2 > 0 ? Math.round(Number(side2)) : "";
					break;
				case 3:
					elementS.value = side3 > 0 ? Math.round(Number(side3)) : "";
					break;
			}
		}
	});

	if (changeMade) {
		completePolygon();
		setChangeMade(false);
	}

	return (
		<>
			<div>
				<svg width="200" height="60" xmlns="http://www.w3.org/2000/svg">
					<circle cx={indent + 20} cy="10" r="8" strokeWidth="2" stroke="black" fill="white"
						onClick={() => setRadioSelection(1)} />
					{radioSelection == 1 && <circle cx={indent + 20} cy="10" r="5" stroke="none" fill="black" />}
					<text x={indent + 37} y="17">Triangle</text>
					<circle cx={indent + 20} cy="42" r="8" strokeWidth="2" stroke="black" fill="white"
						onClick={() => setRadioSelection(2)} />
					{radioSelection == 2 && <circle cx={indent + 20} cy="42" r="5" stroke="none" fill="black" />}
					<text x={indent + 37} y="49">Quadrilateral</text>
				</svg>
				{radioSelection > 0 && polygonOutput()}
				{radioSelection > 0 && triangleInputs()}
			</div >
		</>
	);*/

	return;
}
